import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./Screens/Login";
import SignUp from "./Screens/SignUp";
import AccountSetup from "./Screens/AccountSetup";
import ForgotPassword from "./Screens/ForgotPassword";
import ForgotPassSent from "./Screens/ForgotPassSent";
import Dashboard from "./Screens/Dashboard";
import Branches from "./Screens/Branches";
import Reports from "./Screens/Reports";
import Notifications from "./Screens/Notifications";
import Settings from "./Screens/Settings";
import Home from "./Screens/Home";
import { ProfileProvider } from "./context/ProfileContext";
import { AuthProvider } from "./context/Authcontext/AuthContext";
import { UserProvider, UserDataFetcher } from "./context/UserContext";
import ProtectedRoute from "./context/Authcontext/ProtectedRoute";
import Transactions from "./Screens/Transactions";
import ReportIssue from "./Screens/ReportIssues";
import Career from "./Screens/HomeScreens/Career";
import PrivacyPolicy from "./Screens/HomeScreens/PrivacyPolicy";
import AboutUs from "./Screens/HomeScreens/AboutUs";
import TermsOfService from "./Screens/HomeScreens/TermsOfService";

function App() {
  return (
    <AuthProvider>
      <ProfileProvider>
        <UserProvider>
          <Router>
            <UserDataFetcher />
            <Routes>
              <Route path="/Home" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<SignUp />} />
              <Route path="/account-setup" element={<ProtectedRoute><AccountSetup /></ProtectedRoute>} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/forgot-pass-sent" element={<ForgotPassSent />} />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/branches"
                element={
                  <ProtectedRoute>
                    <Branches />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/reports"
                element={
                  <ProtectedRoute>
                    <Reports />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/notifications"
                element={
                  <ProtectedRoute>
                    <Notifications />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/settings"
                element={
                  <ProtectedRoute>
                    <Settings />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/Transactions"
                element={
                  <ProtectedRoute>
                    <Transactions />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ReportIssue"
                element={
                  <ProtectedRoute>
                    <ReportIssue />
                  </ProtectedRoute>
                }
              />
              <Route
              path="/career"
              element={
                  <Career/>
              }
              />
              <Route
              path="/privacyPolicy"
              element={
                  <PrivacyPolicy/>
              }
              />
              <Route
              path="/aboutUs"
              element={
                  <AboutUs/>
              }
              />
              <Route
              path="/termsOfService"
              element={
                  <TermsOfService/>
              }
              />
              <Route path="*" element={<Home />} />
            </Routes>
          </Router>
        </UserProvider>
      </ProfileProvider>
    </AuthProvider>
  );
}

export default App;
